export default "__VITE_ASSET__Cn08xbc7__"